import { LucideIconName } from '@bm-js/atlascloud-shared'
import { LucideIcons } from '../cnst/lucide.cnst'

interface Props {
  name: LucideIconName | undefined
  className?: string
  onClick?: () => void
  strokeWidth?: number
  size?: number
}

export const Icon = ({
  name,
  className,
  onClick,
  strokeWidth,
  size,
}: Props) => {
  if (!name) return null
  const Icon = LucideIcons[name]
  if (!Icon) return null
  return (
    <Icon
      strokeWidth={strokeWidth}
      size={size}
      className={className}
      onClick={onClick}
    />
  )
}
